import { apiFetch } from "../useApi";

export default async function getProfile({ queryKey }) {
  const response = await apiFetch(`/me/profile`);
  return response.json();
}
